/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-09-09 16:29:42
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  pleaseSelectATaskStatus: '请选择任务状态',
  searchAssetName: '搜索对象名称',
  pleaseChooseTheType: '请选择类型',
  createStartTime: '创建开始时间',
  createEndTime: '创建结束时间',
  lastModifiedStartTime: '最后修改开始时间',
  lastModifiedEndTime: '最后修改结束时间',
  assetName: '对象名',
  schedule: '进度',
  creationTime: '创建时间',
  lastModified: '最后修改时间',
  theCompletedPdfFileConversionOcrTypeCanNoLongerBeOperated:
    '已完成的pdf文件转换Ocr类型无法再进行操作',
  thisOperationWillBeBatched: '此操作将进行批量',
  thisOperationWillBe: '此操作将进行',
  whetherToContinue: '是否继续',
  pleaseTickRequired: '请勾选需要',
  item: '的项',
  conversionNotCompleteWaitAMoment: '转换未完成，稍等',
  pleaseSelectTheDataToDelete: '请选择要删除的数据',
  theSelectedDataContainsDataWithAStatusOtherThanFailed: '所选数据包含状态不为失败的数据',
  operationWillPermanentlySelectTheDataWhetherToContinue: '此操作将永久所选数据, 是否继续',
  successfullyDeleted: '删除成功',
  ParsingTheModelInformationObject: '正在解析模型信息对象',
}
